import { fetchAPI } from "packs/api";

// Get cookie prefix at runtime to handle script loading order
function getCookiePrefix() {
  return window.appconfig?.cookie_prefix || 'pp_dd';
}

document.addEventListener("DOMContentLoaded", () => {
  couponClick();
})

function couponClick(){
  let couponElements = document.querySelectorAll(".click_coupons_code");
  couponElements.forEach(element => {
    // Skip if already initialized
    if (element.dataset.couponClickInitialized) return;
    element.dataset.couponClickInitialized = 'true';

    element.addEventListener("click", function (event) {
      // Get data attributes
      let coupon_type = this.dataset.coupon_type;
      let value = this.dataset.href;
      let topic_url = this.dataset.hrefAlt;
      let topicOwner = this.dataset.topicowner || 0;
      let pagePosition = this.dataset.pageposition || '';

      // Device detection
      let device = is_device_mobile() ? 'mobile' : 'desktop';

      // Get UTM parameters from cookies
      let utm_campaign = Cookies.get(`${getCookiePrefix()}_utm_campaign`);
      let utm_medium = Cookies.get(`${getCookiePrefix()}_utm_medium`);
      let utm_source = Cookies.get(`${getCookiePrefix()}_utm_source`);
      let gclid = Cookies.get(`${getCookiePrefix()}_gclid`);
      let fbclid = Cookies.get(`${getCookiePrefix()}_fbclid`);

      // Get current user ID
      let user_value = 0;
      let current_user_id = document.getElementById("CurrentUserID");
      if (current_user_id) {
        user_value = current_user_id.value;
      }

      // Append UTM parameters to the URL
      if (value) {
        value = appendUtmParams(value, {
          utm_campaign,
          utm_medium,
          utm_source,
          gclid,
          fbclid,
          user_value,
          device,
          topicOwner,
          pagePosition
        });
      }

      if (value !== null && topic_url !== null) {
        if (!coupon_type) {
          window.open(topic_url);
          window.location.href = value;
        } else if (coupon_type && coupon_type == 'coupon_popup') {
          window.open(value, '_blank');
        } else {
          window.open(value);
          window.location.href = topic_url;
        }
        window.focus();
        update_outbound_click(topic_url);
      }
    });
  });
}

// Append UTM params to URL (aligned with desidime_1.3 logic)
function appendUtmParams(url, params) {
  const { utm_campaign, utm_medium, utm_source, gclid, fbclid, user_value, device, topicOwner, pagePosition } = params;

  // Use empty string for undefined values to avoid "undefined" in URLs
  const safeUtmMedium = utm_medium || '';
  const safeUtmSource = utm_source || '';

  if (url.includes('/visit')) {
    // For /visit URLs, append parameters with ?
    if (!utm_campaign) {
      let queryString = `ts=direct&dduid=${user_value}&client=${device}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
      url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
    } else {
      // Build params with proper null checks (like desidime_1.3)
      if (fbclid) {
        let queryString = `ts=Xutm_${utm_campaign}&dduid=${user_value}&client=${device}&us=${safeUtmSource}&um=${safeUtmMedium}&fbclid=${fbclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
        url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
      } else if (gclid) {
        let queryString = `ts=Xutm_${utm_campaign}&dduid=${user_value}&client=${device}&us=${safeUtmSource}&um=${safeUtmMedium}&gclid=${gclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
        url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
      } else {
        let queryString = `ts=Xutm_${utm_campaign}&dduid=${user_value}&client=${device}&us=${safeUtmSource}&um=${safeUtmMedium}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
        url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
      }
    }
  } else if (url.includes('ref=')) {
    // For /links URLs with ref parameter, modify the ref value
    if (!utm_campaign) {
      url = url.replace(/(ref=)([^&#]*)/, `$1$2&ts=direct&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}`);
    } else {
      // Build params with proper null checks (like desidime_1.3)
      if (fbclid) {
        let utmString = `Xutm_${utm_campaign}&ts=${utm_campaign}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${safeUtmSource}&um=${safeUtmMedium}&fbclid=${fbclid}`;
        url = url.replace(/(ref=)([^&#]*)/, `$1$2${utmString}`);
      } else if (gclid) {
        let utmString = `Xutm_${utm_campaign}&ts=${utm_campaign}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${safeUtmSource}&um=${safeUtmMedium}&gclid=${gclid}`;
        url = url.replace(/(ref=)([^&#]*)/, `$1$2${utmString}`);
      } else {
        let utmString = `Xutm_${utm_campaign}&ts=${utm_campaign}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${safeUtmSource}&um=${safeUtmMedium}`;
        url = url.replace(/(ref=)([^&#]*)/, `$1$2${utmString}`);
      }
    }
  } else {
    // For other URLs, append as query parameters
    if (!utm_campaign) {
      let queryString = `ts=direct&dduid=${user_value}&client=${device}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
      url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
    } else {
      // Build params with proper null checks (like desidime_1.3)
      if (fbclid) {
        let queryString = `ts=Xutm_${utm_campaign}&dduid=${user_value}&client=${device}&us=${safeUtmSource}&um=${safeUtmMedium}&fbclid=${fbclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
        url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
      } else if (gclid) {
        let queryString = `ts=Xutm_${utm_campaign}&dduid=${user_value}&client=${device}&us=${safeUtmSource}&um=${safeUtmMedium}&gclid=${gclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
        url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
      } else {
        let queryString = `ts=Xutm_${utm_campaign}&dduid=${user_value}&client=${device}&us=${safeUtmSource}&um=${safeUtmMedium}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
        url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
      }
    }
  }

  return url;
}

function update_outbound_click(url) {
  fetchAPI("/update_outbound_click", "POST", { url: url }, "text")
    .then(response => {
      // Backend returns {recorded: true/false}
      // No action required
    })
    .catch(error => {
      console.error("Click tracking failed:", error);
    });
}

function is_device_mobile() {
  return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph/i.test(navigator.userAgent.substr(0, 4)));
}

window.couponClick = couponClick;
